import React, { Component } from 'react'
import { HashRouter, Link } from 'react-router-dom'
import { setRegPage, currentWidget, popupOpenClose, setDeviceConfigFailed, setMobileTVPage, setFailScreen, openSMSWidget, setOpenProfileImage, setShowCustomPopup } from '../../action/action'
import { connect } from 'react-redux'
import propTypes from 'prop-types';
import { nonCompWidgetClick } from '../../layout2.0/JS/widgetHandling'
import { setRoomControlPage } from '../../layout2.0/action/action'
import { setOpenDemoCamera, setGoHome, setLoader, setLoginRequired, setExternalSignIn, setDNDon, setMURon } from '../../layout2.0/action/homeAction'
import { closeOrderPopUp } from '../../layout2.0/action/hCommerce2'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { guestDetails, sendAnalytics } from "../../action/homeAction"
import { withTranslation } from 'react-i18next';
import { sendAcCommand } from '../../action/roomControlAction'
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction';
import { getCdnUrl } from '../../config/config';
import { CMSPath } from '../../config/constant';

class SquareLargeWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widgetData: {}
        }
    }

    setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                this.props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                this.props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                this.props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                this.props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }
    componentDidMount() {
        if (this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }

    componentDidUpdate(preProb) {
        if (preProb.widgetList !== this.props.widgetList && this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }
    onWidgetClick = async (widget) => {
        let room = localStorage.getItem('room')
        console.log("current widget", widget)
        if (widget.path) {
            await this.props.currentWidget(widget);
            if (widget.path === "/RoomControl2") {
                this.setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/mobileTv") {
                if(!room){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                } else {
                    this.props.setMobileTVPage(true);
                }

            }
            if (widget.path === "/happy") {
                if(this.props.survey.needsLogin)
                if(!room || room === "null"){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                }
            }
            if (widget.widgetType === "Hcommerce") {
                this.props.setHcommerceWidget(widget);
            }
        } else {
           
            nonCompWidgetClick(widget, this.props)
        }
    }

    render() {
        return (
            <HashRouter>

            <Link exact to={this.state.widgetData.path ? this.state.widgetData.path : "/"}
                                onClick={() => { this.onWidgetClick(this.state.widgetData) }}
                            className={`${this.state.widgetData.btnImageUrl ?
                    "tile-lg img-banner tile-container"
                    : "tile-lg tile-container"} ${this.state.widgetData.widgetType} ${this.state.widgetData.widgetMetaHtmlId ? this.state.widgetData.widgetMetaHtmlId:""}`}
                
                style={
                    this.state.widgetData.compImage ? {
                        // backgroundImage: `url('${this.state.widgetData.compImage}')`,
                        backgroundImage: `url(${getCdnUrl(CMSPath, this.state.widgetData.btnImageUrl)})`,
                        backgroundSize: "cover",
                        backgroundPositionX: "center",
                        backgroundPositionY: "top"
                    } : {}
                }
            >
                <div className="content">
                    <div className="label">
                        <p class="heading" dangerouslySetInnerHTML={{__html: this.state.widgetData.widgetTitle ? this.state.widgetData.widgetTitle : ""}} ></p>
                        {/* <p dangerouslySetInnerHTML={{__html: this.state.widgetData.widgetDesc ? this.state.widgetData.widgetDesc : ""}} ></p> */}
                        {this.state.widgetData.widgetDesc && <div class="subheading" dangerouslySetInnerHTML={{__html:this.state.widgetData.widgetDesc }}></div>}
                    </div>
                    {this.state.widgetData.buttonTitle && <div className="controls">
                        <Link style = {{
                            backgroundColor: this.props.menuColor.assetBackgroundSelectorColor,
                            color: this.props.menuColor.assetFontSelectorColor,
                        }} exact to={this.state.widgetData.path ? this.state.widgetData.path : "/"}
                            onClick={() => { this.onWidgetClick(this.state.widgetData) }}
                            className="button btn-action">
                            {this.state.widgetData.buttonTitle ? this.state.widgetData.buttonTitle : ""}
                        </Link>
                    </div>}
                </div>
            </Link >
            </HashRouter>
        )
    }
}

SquareLargeWidget.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        openExternalLinkInSameTab: state.store2.openExternalLinkInSameTab,
        externalSignIn: state.store2.externalSignIn,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,


    }
}
export default connect(
    mapStateToProps,
    {
        currentWidget,
        popupOpenClose,
        openSMSWidget,
        setOpenProfileImage,
        setRoomControlPage,
        setDeviceConfigFailed,
        setOpenDemoCamera,
        setRegPage,
        sendAcCommand,
        closeOrderPopUp,
        setHcommerceWidget,
        setMobileTVPage,
        guestDetails,
        sendAnalytics,
        setGoHome,
        setLoader,
        setDNDon,
        setMURon,
        setFailScreen,
        setLoginRequired,
        setOpenExternalLinkInSameTab,
        setShowCustomPopup,
        setExternalSignIn
    }
)(withTranslation('translations')(SquareLargeWidget));